import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

const options = {
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
    Authorization:
      "Bearer " + localStorage.getItem("vue-authenticate.vueauth_access_token"),
  },
};

function saveDealInvestment(payload, dealId) {
  return axios.post(`${url}/investor/deal/investment/${dealId}`, payload, options);
}

function getDealInvestments(companyId) {
    return axios.get(`${url}/investor/deal/investments/${companyId}`, options);
}

function getDealInvestment(companyId) {
  return axios.get(`${url}/investor/deal/investment/${companyId}`, options);
}

export default {
    saveDealInvestment,
    getDealInvestments,
    getDealInvestment
};
